import { useStaticQuery, graphql } from "gatsby"
import type { BlogSettingsQuery } from "../graphql.gen"
import type { ColorTheme } from "../slices/PageDataBodyCallToAction"

export function useBlogSettings() {
	const result = useStaticQuery<BlogSettingsQuery>(graphql`
		query BlogSettings {
			prismicSettings {
				data {
					blog_cta_heading {
						text
					}
					blog_cta_text {
						richText
					}
					blog_cta_link {
						url
					}
					blog_cta_link_text
					blog_cta_color_theme
				}
			}
		}
	`)

	const data = result.prismicSettings?.data

	return {
		ctaHeading: data?.blog_cta_heading?.text,
		ctaText: data?.blog_cta_text?.richText,
		ctaHref: data?.blog_cta_link?.url,
		ctaLinkText: data?.blog_cta_link_text,
		ctaColorTheme: (data?.blog_cta_color_theme?.toLowerCase() ??
			"black") as ColorTheme,
	}
}
